<template>
  <div>
    <b-container fluid>
      <!-- User Interface controls -->
      <b-row>
        <b-col sm="4" md="4" class="my-1">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>

      <!-- Main table element -->
      <b-table
        show-empty
        striped
        hover
        :items="items"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :busy="loading"
      >
        <template v-slot:table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <!-- A custom formatted column -->
        <template v-slot:cell(package)="row">
          {{ getLocalPackageFull(row.item.package) }}
          <span v-if="row.item.note">
            <b-button
              class="btn-sm btn-light infobtnpackage"
              :id="`popover-${row.item.id}`"
              variant="primary"
              ><i class="fas fa-info-circle infopackage"></i
            ></b-button>
            <b-popover
              :target="`popover-${row.item.id}`"
              triggers="hover focus"
              :content="row.item.note"
            ></b-popover>
          </span>
        </template>

        <template v-slot:cell(activate_date)="data">
          {{ getFormatDateDisplay(data.value) }}
        </template>

        <template v-slot:cell(created_at)="data">
          {{ getFormatDateTimeDisplay(data.value) }}
        </template>

        <template v-slot:cell(expire_date)="data">
          <span :class="checkExpire(data.value)">{{
            getFormatDateDisplay(data.value)
          }}</span>
        </template>
        <template v-slot:cell(status)="data">
          <i :class="checkStatus(data.value)"></i>
        </template>
        <template v-slot:cell(actions)="row">
          <!--
          <b-button
            size="sm"
            @click.prevent="deletePackage"
            class="mr-1"
            variant="secondary"
          >
            <i class="fas fa-trash-alt"></i>
          </b-button>
          -->

          <b-button
            size="sm"
            @click.prevent="showModal(row.item)"
            variant="secondary"
            v-if="row.item.status != 'LOCK'"
          >
            <i class="fas fa-pencil-alt"></i>
          </b-button>
        </template>
      </b-table>
    </b-container>
    <modals-container name="member_updatepackage_modal" />
  </div>
</template>
<script>
import { isAuthLv1, isAuthLv2 } from "./../js/utils/global.js";
import {
  packageTypeFull,
  packageDurationFull,
  getPackageFull,
} from "./../js/utils/datamanip.js";
import {
  formatDateDisplay,
  formatDateTimeDisplay,
} from "./../js/utils/date.js";
import Vue from "vue";
import VModal from "vue-js-modal";
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } });

import MemberPackageEdit from "./MemberPackageEdit.vue";
export default {
  props: { memberid: Number },
  data() {
    return {
      loading: false,
      fields: [
        {
          key: "id",
          label: "MP ID",
        },
        {
          key: "ref_number",
          label: "Ref #",
        },
        {
          key: "package",
          label: "Package",
        },
        {
          key: "session_use",
          label: "Used",
        },
        {
          key: "session_max",
          label: "Total",
        },
        {
          key: "activate_date",
          label: "Activation Date",
        },
        {
          key: "expire_date",
          label: "Expiration Date",
        },
        {
          key: "created_at",
          label: "Purchase Date",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "actions",
          label: "",
        },
      ],
      items: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 20],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      memberpackage: {
        ref_number: null,
        activate_date: null,
        package: {
          type: null,
          duration: null,
        },
        note: null,
      },
    };
  },
  mounted() {
    this.getPackage();
  },
  computed: {
    isAuthLv2,
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  methods: {
    showModal(item) {
      //console.log(item);
      this.memberpackage = item;

      this.$modal.show(
        MemberPackageEdit,
        {
          //--- Component property
          memberpackage: this.memberpackage,
          //selfmodal: this.$modal,
        },
        {
          //-- Modal Params
          draggable: false,
          height: "auto",
          scrollable: true,
          adaptive: true,
        },
        {
          //-- Modal event listener
          "before-close": (event) => {
            //console.log(event);
            //console.log("this will be called before the modal closes");
            this.getPackage();
          },
          "before-open": (event) => {
            //console.log("this will be called before the modal open");
          },
          closed: (event) => {},
        },
        {}
      );
    },
    deletePackage() {},
    editPackage() {},
    async getPackage() {
      this.loading = true;
      await axios
        .get("/api/members/package/" + this.memberid)
        .then((response) => {
          //console.log(response.data.data);
          this.items = response.data.data;
          this.totalRows = this.items.length;
          //console.log(response.data.data);
          this.loading = false;
        });
    },
    getLocalPackageFull(key) {
      return getPackageFull(key);
    },
    checkExpire(value) {
      return "";
      let target = new Date(value);
      let today = new Date();
      if (target < today) {
        return "expired";
      } else {
        return "active";
      }
    },
    checkStatus(value) {
      switch (value) {
        case "ACTIVE":
          return "fas fa-grin-beam status_active";
          break;
        case "FREEZE":
          return "fas fa-snowflake status_expire";
          break;
        case "INACTIVE":
          return "fas fa-sad-tear status_freeze";
        case "LOCK":
          return "fas fa-lock status_lock";
          break;
        default:
          break;
      }
    },
    getFormatDateDisplay(date) {
      return formatDateDisplay(date);
    },
    getFormatDateTimeDisplay(date) {
      return formatDateTimeDisplay(date);
    },
  },
};
</script>
<style scoped>
.expired {
  color: #f00;
  font-weight: bolder;
}
.freeze {
  color: blue;
  font-weight: bolder;
}
.active {
  color: green;
  font-weight: bolder;
}
.status_active {
  font-size: 2em;
  color: green;
}
.status_freeze {
  font-size: 2em;
  color: red;
}
.status_expire {
  font-size: 2em;
  color: blue;
}
.status_lock {
  font-size: 2em;
  color: red;
}
.infopackage {
  font-size: 1.5em;
  color: #007bff;
}
.infobtnpackage {
  padding: 0;
  background-color: transparent;
  border-color: transparent;
}
</style>
